import IdentifiedLearner from './identified-learner';

<template>
  <div class="header">
    {{yield}}
    <IdentifiedLearner />
  </div>
</template>
